<button mat-button style="padding: 0">
  <i *ngIf="direction === 'left'" class="uil uil-arrow-left" style="font-size: 25px"></i>
  <span>{{ label | uppercase }}</span>
  <i *ngIf="icon" class="uil uil-{{icon}}" style="font-size: 25px"></i>
  <i *ngIf="direction === 'right'" class="uil uil-arrow-right" style="font-size: 25px"></i>
</button>

